import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Injectable, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatTreeNestedDataSource } from '@angular/material/tree';

import { StudentService } from '../../children/service/student.service';
import { COESTUDENT, CoeRelatedStudent, STUDENT } from 'src/app/component/common-components/multi-select-coe-student/coe-related-student';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

@Component({
    selector: 'app-view-coe-child-info',
    templateUrl: './view-coe-child-info.component.html',
    styleUrls: ['./view-coe-child-info.component.scss']
})
export class ViewCoeChildInfoComponent implements OnInit {
    @Input() partyId: number;
    @Input() CoeRelatedStudents: CoeRelatedStudent[];
    @Input() spinner: boolean;
    @Output() eventCoeStudents = new EventEmitter<STUDENT[]>();
    node: CourseNode[] = [];

    nestedDataSource = new MatTreeNestedDataSource<CourseNode>();
    nestedTreeControl = new NestedTreeControl<CourseNode>((node) => node.children);
    testIds: number[] = [];
    @ViewChild(CdkVirtualScrollViewport) virtualScroll: CdkVirtualScrollViewport;

    constructor(private studentService: StudentService) {}

    ngOnInit(): void {
        if (this.CoeRelatedStudents.length > 0) {
            this.transformCOECourseNode(this.CoeRelatedStudents);
            this.nestedDataSource.data = this.node;
        } else {
            this.nestedDataSource.data = [];
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.CoeRelatedStudents.length > 0) {
            this.transformCOECourseNode(this.CoeRelatedStudents);
            this.nestedDataSource.data = this.node;
        }
    }

    getCoeRelatedStudents(partyId: number) {
        let coeRelatedStudentPayload: any = { party: { ID: partyId } };

        this.studentService.getCoeRelatedStudents(coeRelatedStudentPayload).subscribe((x) => {
            if (x['coes'] === undefined) {
                if (x['msg'] !== undefined) {
                    //this.msg = x['msg'];
                    this.nestedDataSource.data = [];
                }
            } else {
                this.CoeRelatedStudents = JSON.parse(x['coes']);
                this.transformCOECourseNode(this.CoeRelatedStudents);
                this.nestedDataSource.data = this.node;
            }
        });
    }
    transformCOECourseNode(c: CoeRelatedStudent[]) {
        this.node = [];
        for (let i = 0; i < c.length; i++) {
            let parentTempNode = new CourseNode();
            parentTempNode.id = c[i].ID;
            parentTempNode.name = c[i].COE_NUMBER;
            let coeStudents: Array<COESTUDENT> = c[i].COE_STUDENTS;
            parentTempNode.children = [];
            for (let k = 0; k < coeStudents.length; k++) {
                let a = new CourseNode();
                a.id = coeStudents[k].STUDENTS_ID;
                a.msdnumber = coeStudents[k].STUDENT.MSD_NUMBER;
                a.name = coeStudents[k].STUDENT.PERSON.LAST_NAME + ',' + coeStudents[k].STUDENT.PERSON.FIRST_NAME;
                parentTempNode.children[k] = a;
            }
            this.node.push(parentTempNode);
        }
    }

    hasNestedChild(index: number, node: CourseNode) {
        return node?.children?.length! > 0;
    }

    toggle(event: MatCheckboxChange, node: CourseNode) {
        let students: Array<STUDENT> = [];

        if (event.source.checked) {
            /*if (this.testIds.find((x) => x == node.id) == undefined)*/
            this.testIds.push(node.id);
        } else {
            this.RemoveElementFromArray(node.id);
        }

        var uniqueStudentId = this.testIds.filter(function (elem, index, self) {
            return index === self.indexOf(elem);
        });

        uniqueStudentId.forEach((uniqStudentId) => {
            let s = new STUDENT();
            this.CoeRelatedStudents.forEach((coeRelatStudents) => {
                s = coeRelatStudents.COE_STUDENTS.find((y) => y.STUDENTS_ID == uniqStudentId)?.STUDENT!;
                if (s != undefined && s.ID > 0) {
                    if (students.findIndex((stu) => stu.ID == s.ID) == -1) {
                        students.push(s);
                    }
                }
            });
        });

        this.eventCoeStudents.emit(students);
    }

    RemoveElementFromArray(findElement: number) {
        /*this.testIds.forEach((value, index) => {
            if (value == findElement) this.testIds.splice(index, 1);
        });*/
        const index = this.testIds.indexOf(findElement, 0);
        if (index > -1) {
            this.testIds.splice(index, 1);
        }
    }
}

class CourseNode {
    name: string;
    id: number;
    msdnumber: string;

    children?: CourseNode[];
}
